import { Injectable } from '@angular/core';
import { BreadService } from '../bread.service';
import { Product } from '@app/core/models/product.models';
import { BaseCrudService } from '../bread-crud.service';

@Injectable({ providedIn: 'root' })
export class ShopService extends BaseCrudService<Product> {
  protected model = 'shops';

  constructor(bread: BreadService) {
    super(bread);
  }
}
